import { Outlet } from "react-router-dom";
import SideBar from "../components/Sidebar";
import { useState, useEffect } from "react";
import axios from "axios";
import { useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/store";
import LogoutModal from "../components/LogoutModal";
import { checkTokenExpiration } from "../redux/thunk";
import { HiOutlineMenu } from "react-icons/hi";
import NotificationBadge from "../components/NotificationBadge";

export const BasePage = () => {
  const { token } = useAppSelector((store: RootState) => store.auth);
  const [tabNavigation, setTabNavigation] = useState(false);
  const { lastName } = useAppSelector((store: RootState) => store.auth);
  const [role, setRole] = useState("");
  const [showSidebar, setShowSidebar] = useState(true);
  const [src, setSrc] = useState("");
  const [modals, setModals] = useState({
    logout: false,
  });
  const auth = sessionStorage.getItem("authState");
  const authState = auth && JSON.parse(auth);


  useEffect(() => {
    getAllAdmins();
  }, [])


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setTabNavigation(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (token) {
      checkTokenExpiration();
    }
  }, [token]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkTokenExpiration();
    }, 900000); // 15 minutes

    return () => clearInterval(intervalId);
  }, []);

  const toggleTabNavigation = () => {
    setTabNavigation(!tabNavigation);
  };

  const openModal = (modalName: string) => {
    setModals((prevState) => ({ ...prevState, [modalName]: true }));
  };

  const closeModal = (modalName: string) => {
    setModals((prevState) => ({ ...prevState, [modalName]: false }));
  };

  const getAllAdmins = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-admins-except-superadmin`
      );
      const filteredAdmin = res.data.filter(
        (admin: any) => admin.lastName === lastName
      );
      setRole(filteredAdmin[0].adminRole);
    } catch (error) { }
  };

  return (
    <div className="lg:flex">
      <div className="transition">
        <SideBar
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          tabNavigation={tabNavigation}
          toggleTabNavigation={toggleTabNavigation}
          openModal={() => openModal("logout")}
          role={role}
          setSrc={setSrc}
        />
      </div>
      <div
        className={`w-full ml-0 overflow-x-hidden ${showSidebar && "lg:ml-[260px]"
          }`}
      >
        {/* ── Persistent top bar: visible on ALL pages and ALL screen sizes ── */}
        <div className="flex items-center justify-between px-4 2xl:px-8 py-3 border-b border-gray-100 bg-white sticky top-0 z-30">
          <button
            type="button"
            onClick={toggleTabNavigation}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#008060] text-white shadow-md focus:outline-none"
            aria-label="Toggle navigation menu"
          >
            <HiOutlineMenu className="w-5 h-5" />
          </button>
          <div className="ml-auto flex items-center gap-3">
            <NotificationBadge />
            <figure className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
              <img src="/assets/Avatar.png" alt="avatar" className="w-full h-full object-cover" />
            </figure>
            <div className="text-left">
              <p className="font-semibold text-sm">{authState?.firstName || "Admin"}</p>
              <p className="text-gray-400 text-xs capitalize">{authState?.adminLevel || "Superadmin"}</p>
            </div>
          </div>
        </div>

        <div className="py-4 px-4 2xl:px-8 pb-8">
          {src ? (
            <iframe
              src={src}
              className="w-full h-screen border-none"
              title="web app"
            ></iframe>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
      {modals.logout && <LogoutModal closeModal={() => closeModal("logout")} />}
    </div>
  );
};
